export default "__VITE_ASSET__BCAj4bcw__"